import Grid from '@mui/material/Grid';
import React from 'react';
import { ROUTES } from '~/constants/ROUTES';
import getIcon from '~/helpers/getIcon';
import LinkButton from '../LinkButton';
import { StyledDialog, StyledDialogContent, StyledGridContainer, StyledIconButton, StyledSignOutButton } from './styles';
const IconClose = getIcon('actions.close');
const IconHome = getIcon('general.home');
const IconSignout = getIcon('actions.signout');
export interface DialogUserActionsProps {
  onClose: () => void;
  open: boolean;
}
export const DialogUserActions: React.FC<DialogUserActionsProps> = ({
  onClose,
  open
}: DialogUserActionsProps): React.ReactElement<DialogUserActionsProps> => {
  return <StyledDialog aria-label="User Actions" aria-labelledby="userActions" maxWidth="sm" onClose={onClose} open={open} role="dialog" sx={{
    padding: 0
  }} data-sentry-element="StyledDialog" data-sentry-component="DialogUserActions" data-sentry-source-file="index.tsx">
      <div aria-label="User Actions" id="userActions" role='region' />
      <StyledDialogContent data-sentry-element="StyledDialogContent" data-sentry-source-file="index.tsx">
        <StyledGridContainer container spacing={2} data-sentry-element="StyledGridContainer" data-sentry-source-file="index.tsx">
          <Grid item data-sentry-element="Grid" data-sentry-source-file="index.tsx">
            <LinkButton aria-label="Go to Home Page" color="info" href={ROUTES.INDEX} onClick={onClose} startIcon={<IconHome />} variant="contained" data-sentry-element="LinkButton" data-sentry-source-file="index.tsx">
              Go to Home Page
            </LinkButton>
          </Grid>
          <Grid item data-sentry-element="Grid" data-sentry-source-file="index.tsx">
            <StyledSignOutButton aria-label="Sign Out" href={ROUTES.SIGNOUT} onClick={onClose} startIcon={<IconSignout />} variant="text" data-sentry-element="StyledSignOutButton" data-sentry-source-file="index.tsx">
              Sign Out
            </StyledSignOutButton>
          </Grid>
        </StyledGridContainer>
        <StyledIconButton aria-label="Close User Actions Dialog" autoFocus onClick={onClose} data-sentry-element="StyledIconButton" data-sentry-source-file="index.tsx">
          <IconClose data-sentry-element="IconClose" data-sentry-source-file="index.tsx" />
        </StyledIconButton>
      </StyledDialogContent>
    </StyledDialog>;
};
export default DialogUserActions;